import { c as _c } from "react/compiler-runtime";
import { NumberDisplay, SwitchPill, Tooltip } from "@opensea/ui-kit";
import { bn } from "@opensea/utils";
import { useMemo } from "react";
export function CurrencyQuantityUsdPresetButton(t0) {
  const $ = _c(23);
  const {
    currency,
    usdAmount,
    quantity,
    onClick
  } = t0;
  let t1;
  bb0: {
    if (!currency?.usdPrice || bn(currency.usdPrice).lte(0)) {
      t1 = 0;
      break bb0;
    }
    let t2;
    if ($[0] !== currency.decimals || $[1] !== currency.usdPrice || $[2] !== usdAmount) {
      t2 = bn(usdAmount).div(currency.usdPrice).decimalPlaces(currency.decimals).toNumber();
      $[0] = currency.decimals;
      $[1] = currency.usdPrice;
      $[2] = usdAmount;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = t2;
  }
  const tokenQuantity = t1;
  let t2;
  bb1: {
    if (!(quantity && currency?.usdPrice)) {
      t2 = false;
      break bb1;
    }
    let t3;
    if ($[4] !== currency.usdPrice || $[5] !== quantity || $[6] !== usdAmount) {
      const currentUsdValue = bn(quantity).times(currency.usdPrice);
      t3 = currentUsdValue.minus(usdAmount).abs().lt(0.01);
      $[4] = currency.usdPrice;
      $[5] = quantity;
      $[6] = usdAmount;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = t3;
  }
  const checked = t2;
  let t3;
  bb2: {
    if (!currency) {
      t3 = "Select a token";
      break bb2;
    }
    if (!currency.usdPrice || bn(currency.usdPrice).lte(0)) {
      t3 = "USD price unavailable";
      break bb2;
    }
    t3 = undefined;
  }
  const disabledReason = t3;
  const disabled = Boolean(disabledReason);
  const t4 = !disabled;
  let t5;
  if ($[8] !== onClick || $[9] !== tokenQuantity) {
    t5 = () => {
      onClick(tokenQuantity);
    };
    $[8] = onClick;
    $[9] = tokenQuantity;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      maximumFractionDigits: 0
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== usdAmount) {
    t7 = <NumberDisplay custom={t6} display="usd" value={usdAmount} />;
    $[12] = usdAmount;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== checked || $[15] !== disabled || $[16] !== t5 || $[17] !== t7) {
    t8 = <span><SwitchPill checked={checked} disabled={disabled} onClick={t5} variant="transparent">{t7}</SwitchPill></span>;
    $[14] = checked;
    $[15] = disabled;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== disabledReason || $[20] !== t4 || $[21] !== t8) {
    t9 = <Tooltip content={disabledReason} disabled={t4}>{t8}</Tooltip>;
    $[19] = disabledReason;
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}